/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isPlainObject from 'lodash/isPlainObject';
import _sortBy from 'lodash/sortBy';

import { companyService, jobService, surveyService } from 'services';
import commonService from 'services/commonService';
import { sessionPopupService } from 'services/sessionPopupService';
import { freezeBodyScroll, unFreezeBodyScroll } from 'utils';
import { buildDlpUrl } from 'utils';
import { logEventGTM } from 'utils/analyticsGTM';
import { EVENTS, RESUME_SUBSCRIPTION_STATUS } from 'utils/constant';
import { POPUP_ENTRY_POINT } from 'utils/constant';

import { ACTION_TYPES as RB_ACTION_TYPES } from '../resumeBuilder';

import { ACTION_TYPES } from './index';

/**
 * Opens a login popup with details
 * @param {Object} payload
 * @param {String} payload.triggeredBy which cause the modal to open ex. header, card, job, company
 * @param {Boolean} payload.isSave user is saving perticular job
 * @param {Object} payload.bufferedJob
 * @param {String} payload.bufferedContainerTitle
 * @param {Boolean} payload.isDismiss
 */
export const openLoginModal = (payload = {}) => ({
  type: ACTION_TYPES.OPEN_LOGIN,
  payload,
});

export const closeLoginModal = (payload = {}) => ({
  type: ACTION_TYPES.CLOSE_LOGIN,
  payload,
});

export const openLocationInputModal = (payload = {}) => ({
  type: ACTION_TYPES.OPEN_LOCATION_INPUT_POPUP,
  payload,
});

export const closeLocationInputModal = (payload = {}) => ({
  type: ACTION_TYPES.CLOSE_LOCATION_INPUT_POPUP,
  payload,
});

export let openPostSignUpPopup = (payload = {}) => ({
  type: ACTION_TYPES.OPEN_POST_SIGNUP_SURVEY_POPUP,
  payload,
});

export const closePostSignUpPopup = (payload = {}) => ({
  type: ACTION_TYPES.CLOSE_POST_SIGNUP_SURVEY_POPUP,
  payload,
});

/**
 *
 * @param {Object} payload
 * @param {Object} payload.companyInfo
 */
export const openShareModal = (payload = {}) => ({
  type: ACTION_TYPES.OPEN_SHARE,
  payload,
});

export const closeShareModal = (payload = {}) => ({
  type: ACTION_TYPES.CLOSE_SHARE,
  payload,
});

export const updateShowCompanyReviewCard = (payload) => ({
  type: ACTION_TYPES.SHOW_COMPANY_REVIEW_CARD,
  payload,
});

export const updateCompanyReviewCardRating = (payload) => ({
  type: ACTION_TYPES.UPDATE_COMPANY_REVIEW_CARD_RATING,
  payload,
});

export const updateCompanyReviewCardSource = (payload) => ({
  type: ACTION_TYPES.UPDATE_COMPANY_REVIEW_CARD_SOURCE,
  payload,
});

export const updateAddCompanyToFavouriteInQueue = (payload) => ({
  type: ACTION_TYPES.ADD_COMPANY_TO_FAVOURITE_IN_QUEUE,
  payload,
});

const __openFullSurvey = (payload = {}) => ({
  type: ACTION_TYPES.INIT_SURVEY_FULL_PAGE,
  payload,
});

const __openSignUpModal = (payload = {}) => ({
  type: ACTION_TYPES.OPEN_SIGNUP,
  payload,
});

const __openOneTapModal = (payload = {}) => ({
  type: ACTION_TYPES.OPEN_ONE_TAP,
  payload,
});

export const closeSignUpModal = (payload = {}) => ({
  type: ACTION_TYPES.CLOSE_SIGNUP,
  payload,
});

const __updateSurveyStep = (payload = {}) => ({
  type: ACTION_TYPES.UPDATE_SURVEY_STEP,
  payload,
});

export const updateSurveyAnswer = (payload = []) => ({
  type: ACTION_TYPES.UPDATE_ANSWER,
  payload,
});

export const updateSkipQuestion = (payload = []) => ({
  type: ACTION_TYPES.UPDATE_SKIP_QUESTION,
  payload,
});

export const updateSurveyError = (payload = null) => ({
  type: ACTION_TYPES.UPDATE_ERROR,
  payload,
});

export const updateSurveyStep = (newStepNo) => async (dispatch, getState) => {
  if (newStepNo) {
    let surveyStep = Number(newStepNo);
    const {
      modals: { signUp },
    } = getState();
    const oldStep = signUp.surveyStep;
    if (signUp.skipQuestion.length && signUp.skipQuestion.includes(surveyStep)) {
      surveyStep += 1;
    }
    dispatch(
      __updateSurveyStep({
        surveyStep,
        survey_step: `step${newStepNo}`,
        direction: surveyStep < oldStep ? 'rtl' : 'ltr',
      })
    );
  }
};

const dispatchOtherSurveyActions = (payload, dispatch) => {
  if (payload.skipQuestion) {
    dispatch(updateSkipQuestion(payload.skipQuestion));
  }
  // if survey step is defined open survey step n else open survey step 1 every time after opening the survey popup
  if (payload.surveyStep) {
    dispatch(updateSurveyStep(payload.surveyStep));
  } else {
    dispatch(updateSurveyStep(1));
  }
};

export const openSignUpModal =
  (payload = {}, sendResponseToCallee = false) =>
  async (dispatch, getState) => {
    const {
      modals: { signUp },
    } = getState();
    const { survey, src } = payload;
    // remove survey query params as it is survey and survey is list of question
    if (payload.popupType)
      logEventGTM({ dataLayer: { event: 'signUpPrompt', signUpType: payload.popupType } });
    if (signUp.survey !== survey) {
      dispatch(__openSignUpModal({ questionList: [] })); // TODO: review and update way we opening modals, it's a quick fix.
      try {
        const response = await surveyService.fetchSurveyById(payload.survey);
        if (response) {
          payload.survey = response.sName;
          payload.surveyId = response._id;
          // Sort Order By OrderNo
          const questionList = _sortBy(response.qList, (o) => o.orderNo);
          let toBeSkipped = [...(payload?.skipQuestion ?? [])];
          // For src='popup-save' skip question which has name 'email-only-sign-up'
          if (src === 'popup-save' || src === 'popup-dismiss') {
            questionList
              .filter((question) => _get(question, 'question.qName', '') === 'email-only-sign-up')
              .forEach((x) => {
                if (!toBeSkipped.includes(x.orderNo)) toBeSkipped.push(x.orderNo);
              });
          }
          payload.skipQuestion = toBeSkipped;
          payload.questionList = questionList;
          payload.orderQNameList = payload.questionList.map((s) => s.question.qName);
          payload.qListLength = payload.questionList.length;
          if (payload.questionList[payload.qListLength - 1].question.qName === 'review-form') {
            payload.hasReviewForm = true;
            payload.lastTwoQuestionNumber = payload.qListLength - 1;
          }
          payload.surveyStartTimeStamp = Date.now();
          if (!payload.surveyStep && payload.survey_step) {
            payload.surveyStep = payload.survey_step.match(/\d+$/)[0];
          }
        }
        if (sendResponseToCallee) {
          dispatch(__openSignUpModal(payload));
          dispatchOtherSurveyActions(payload, dispatch);
          return payload;
        } else {
          dispatch(__openSignUpModal(payload));
          dispatchOtherSurveyActions(payload, dispatch);
        }
      } catch (e) {
        console.error('e :', e);
      }
    } else {
      // open survey popup without fetch
      dispatch(
        __openSignUpModal({
          entryPoint: payload.entryPoint,
        })
      );
    }
  };

export const openOneTapModal =
  (payload = {}) =>
  async (dispatch, getState) => {
    const {
      modals: { signUp },
    } = getState();
    const { survey, src } = payload;
    // remove survey query params as it is survey and survey is list of question
    if (payload.popupType)
      logEventGTM({ dataLayer: { event: 'signUpPrompt', signUpType: payload.popupType } });
    if (signUp.survey !== survey) {
      try {
        const response = await surveyService.fetchSurveyById(payload.survey);
        if (response) {
          payload.survey = response.sName;
          payload.surveyId = response._id;
          // Sort Order By OrderNo
          const questionList = _sortBy(response.qList, (o) => o.orderNo);
          // For src='popup-save' skip question which has name 'email-only-sign-up'
          if (src === 'popup-save' || src === 'popup-dismiss') {
            payload.questionList = questionList.filter(
              (question) => _get(question, 'question.qName', '') !== 'email-only-sign-up'
            );
          } else {
            payload.questionList = questionList;
          }
          payload.orderQNameList = payload.questionList.map((s) => s.question.qName);
          payload.qListLength = payload.questionList.length;
          if (payload.questionList[payload.qListLength - 1].question.qName === 'review-form') {
            payload.hasReviewForm = true;
            payload.lastTwoQuestionNumber = payload.qListLength - 1;
          }
          payload.surveyStartTimeStamp = Date.now();
          if (!payload.surveyStep && payload.survey_step) {
            payload.surveyStep = payload.survey_step.match(/\d+$/)[0];
          }
        }
        dispatch(__openOneTapModal(payload));
      } catch (e) {
        console.error('e :', e);
      }
    } else {
      // open survey popup without fetch
      dispatch(
        __openOneTapModal({
          entryPoint: payload.entryPoint,
        })
      );
    }
    if (payload.skipQuestion) {
      dispatch(updateSkipQuestion(payload.skipQuestion));
    }
    // if survey step is defined open survey step n else open survey step 1 every time after opening the survey popup
    if (payload.surveyStep) {
      dispatch(updateSurveyStep(payload.surveyStep));
    } else {
      dispatch(updateSurveyStep(1));
    }
  };
/**
 * Init Survey Full Page
 */
export const initSurveyFullPage =
  (payload = {}) =>
  async (dispatch, getState) => {
    const {
      modals: { signUp },
    } = getState();
    const { survey, src } = payload;
    // remove survey query params as it is survey and survey is list of question
    //if (payload.popupType) logEventGTM({ dataLayer: { event: 'signUpPrompt', signUpType: payload.popupType } });
    if (signUp.survey !== survey) {
      try {
        const response = await surveyService.fetchSurveyById(payload.survey);
        if (response) {
          payload.survey = response.sName;
          payload.surveyId = response._id;
          // Sort Order By OrderNo
          const questionList = _sortBy(response.qList, (o) => o.orderNo);
          // For src='popup-save' skip question which has name 'email-only-sign-up'
          if (src === 'popup-save' || src === 'popup-dismiss') {
            payload.questionList = questionList.filter(
              (question) => _get(question, 'question.qName', '') !== 'email-only-sign-up'
            );
          } else {
            payload.questionList = questionList;
          }
          payload.orderQNameList = payload.questionList.map((s) => s.question.qName);
          payload.qListLength = payload.questionList.length;
          if (payload.questionList[payload.qListLength - 1].question.qName === 'review-form') {
            payload.hasReviewForm = true;
            payload.lastTwoQuestionNumber = payload.qListLength - 1;
          }
          payload.surveyStartTimeStamp = Date.now();
          if (!payload.surveyStep && payload.survey_step) {
            payload.surveyStep = payload.survey_step.match(/\d+$/)[0];
          }
        }
        dispatch(__openFullSurvey(payload));
      } catch (e) {
        console.error('e :', e);
      }
    } else {
      // open survey popup without fetch
      dispatch(
        __openFullSurvey({
          entryPoint: payload.entryPoint,
        })
      );
    }
    if (payload.skipQuestion) {
      dispatch(updateSkipQuestion(payload.skipQuestion));
    }
    // if survey step is defined open survey step n else open survey step 1 every time after opening the survey popup
    if (payload.surveyStep) {
      dispatch(updateSurveyStep(payload.surveyStep));
    } else {
      dispatch(updateSurveyStep(1));
    }
  };

export const openPostApplyUXPopup = (payload) => ({
  type: ACTION_TYPES.OPEN_POST_APPLY_UX_POPUP,
  payload,
});

export const closePostApplyUXPopup = () => ({
  type: ACTION_TYPES.CLOSE_POST_APPLY_UX_POPUP,
});

/**
 * DLP related action start
 */

const openAndLoadDLP = (payload) => {
  if (!window.dlpOriginPageCategory) {
    window.dlpOriginPageCategory = window.pageCategory;
  }
  if (window.dlpOriginPageUrl) {
    window.history.replaceState(null, null, window.dlpOriginPageUrl);
  } else {
    window.dlpOriginPageUrl = window.location.href;
    window.history.replaceState(null, null, window.location.href);
    freezeBodyScroll(true);
  }
  return {
    type: ACTION_TYPES.OPEN_DLP,
    payload,
  };
};
/**
 * @param {Object} payload
 * @param {Object} payload.dlpDetail minimal job detail for detail to fetch
 * @param {String} payload.error error messsage to show
 */
const errorDLP = (payload) => ({
  type: ACTION_TYPES.ERROR_DLP,
  payload,
});
const closeDLP = (payload) => {
  if (window.history.state !== null) {
    const url = window.history.state?.referer;
    let parsedURL;

    try {
      parsedURL = new URL(url).pathname;
    } catch (e) {
      console.error(e);
    }

    // dont not go back and cause page remount
    const noBack = ['-jobs/skills/'].findIndex((pathname) => parsedURL?.includes(pathname)) >= 0;

    if (!noBack) {
      history.back();
    }
  }

  if (!payload.listingHash) {
    if (window.dlpOriginPageUrl) {
      history.replaceState(null, null, window.dlpOriginPageUrl);
      delete window.dlpOriginPageUrl;
    }
    if (window.dlpOriginPageCategory) {
      window.pageCategory = window.dlpOriginPageCategory;
      delete window.dlpOriginPageCategory;
    }
  } else {
    history.replaceState(null, null, `${window.dlpOriginPageCategory.toLowerCase()}/`);
  }
  unFreezeBodyScroll();
  return {
    type: ACTION_TYPES.CLOSE_DLP,
    payload,
  };
};
const hideDLP = (payload) => ({
  type: ACTION_TYPES.HIDE_DLP,
  payload,
});
const unhideDLP = (payload) => ({
  type: ACTION_TYPES.UNHIDE_DLP,
  payload,
});
/**
 * @param {Object} payload
 * @param {Object} payload.dlpDetail
 * @param {Object} payload.companyInfo
 */
const jobDetailWithCompanyDLP = (payload) => ({
  type: ACTION_TYPES.SUCCESS_DLP,
  payload,
});

/**
 * open the dlp loading modal as popup
 * @param {Object} payload - job
 * @param {String} payload.listingHash
 * @param {Number} payload.companyID
 */
export const dispatchOpenDLPModal =
  (payload = {}, pageCategory = window.pageCategory, jobDetails = undefined) =>
  async (dispatch, getState) => {
    const dlpDataSuccess = (result) => {
      const {
        modals: {
          dlp: { loading },
        },
      } = getState();
      // if closed without success do not trigget SUCCESS_DLP aaction
      const isExpired = _isEmpty(result[0]);

      if (loading) {
        const dlpDetail = {
          ...result[0],
          jobDLPUrl: buildDlpUrl(!isExpired ? result[0] : payload),
        };
        const companyInfo = result[1];
        // job detail not found
        if (_isEmpty(dlpDetail)) {
          throw new Error('job expired');
        }
        const { open } = getState().modals.dlp;
        if (open) {
          dispatch(
            jobDetailWithCompanyDLP({
              dlpDetail: {
                ...dlpDetail,
                isRemote: payload.isRemote,
                expired: isExpired,
              },
              companyInfo: _isPlainObject(companyInfo) ? companyInfo : {},
            })
          );
          window.signupInterceptorPageCategory = pageCategory;
          window.pageCategory = dlpDetail.easyApplyFlag ? 'DLP - Easy Apply' : 'DLP';
          window.history.pushState(
            {
              referer: window.location.href,
            },
            null,
            `${window.location.origin}${dlpDetail.jobDLPUrl}?modal-dlp=true`
          );
        }
      }
    };

    const dlpDataError = () => {
      const { open } = getState().modals.dlp;
      const error = {
        dlpDetail: payload,
        error:
          "We're sorry, that Job is no longer available. Check out these other jobs you might like.",
      };
      const originPath = new URL(window.dlpOriginPageUrl);
      if (open) {
        dispatch(errorDLP(error));
        unFreezeBodyScroll();
        history.replaceState(null, null, originPath.pathname);
      }
    };

    dispatch(openAndLoadDLP(payload));

    const getJob = jobDetails ? Promise.resolve(jobDetails) : jobService.fetchJobsByHash(payload.listingHash);
    const getCompany = payload.companyID
      ? companyService.getCompanyDetails(payload.companyID)
      : getJob.then((jobInfo) => companyService.getCompanyDetails(jobInfo.companyID));

    const request = [getJob, getCompany];
    Promise.all(request)
      .then((result) => dlpDataSuccess(result))
      .catch(() => dlpDataError());
  };

export const dispatchCloseDLPModal =
  (payload = {}) =>
  async (dispatch, getState) => {
    const {
      modals: { login = {}, signUp = {}, share = {}, easyApply = {} },
    } = getState();
    if (!login.open && !signUp.open && !share.open && !easyApply.open) {
      // close if login, signup, share all closed
      dispatch(closeDLP(payload));
    }
  };

export const dispatchHideDLPModal =
  (payload = {}) =>
  async (dispatch) => {
    dispatch(hideDLP(payload));
  };
export const dispatchUnhideDLPModal =
  (payload = {}) =>
  async (dispatch) => {
    dispatch(unhideDLP(payload));
  };

/**
 * DLP related action end
 */

/** Opens Easy Apply Modal */
export const dispatchEasyApplyOpen =
  (payload = {}) => ({
    type: ACTION_TYPES.JOB_EASY_APPLY_OPEN,
    payload,
  });

/** Closes Easy Apply Modal */
export const dispatchEasyApplyClose =
  (payload = {}) => ({
    type: ACTION_TYPES.JOB_EASY_APPLY_CLOSE,
    payload,
  });

export const dispatchEasyApplySucessNotification = () => (dispatch, getState) => {
  const {
    modals: { showEasyApplySuccessMessage },
  } = getState();
  if (!showEasyApplySuccessMessage) {
    dispatch({
      type: ACTION_TYPES.JOB_APPLY_SUCESS_NOTIFICATION,
      payload: true,
    });
    setTimeout(() => {
      dispatch({
        type: ACTION_TYPES.JOB_APPLY_SUCESS_NOTIFICATION,
        payload: false,
      });
    }, 5000);
  }
};

/**
 * @param {Object} payload article information as object with article_slug and content information
 */
export const dispatchOpenArticlePopup =
  (payload = {}) =>
  (dispatch) => {
    dispatch({
      type: ACTION_TYPES.ADVICE_ARTICLE_POPUP_OPEN,
      payload,
    });
  };

export const dispatchCloseArticlePopup = () => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.ADVICE_ARTICLE_POPUP_CLOSE,
  });
};

export const dispatchOpenSessionTimerSignupModal =
  (payload = {}) =>
  (dispatch, getState) => {
    const {
      modals: { sessionConditionalSignup, sessionTimerSignup },
    } = getState();
    if (!sessionConditionalSignup.open && !sessionTimerSignup.open) {
      freezeBodyScroll();
      dispatch({
        type: ACTION_TYPES.SESSION_TIMER_SIGNUP_OPEN,
        payload,
      });
    }
  };

export const dispatchCloseSessionTimerSignupModal =
  (unFreezeBody = true) =>
  (dispatch) => {
    unFreezeBody && unFreezeBodyScroll();
    dispatch({
      type: ACTION_TYPES.SESSION_TIMER_SIGNUP_CLOSE,
    });
  };

const __openSessionConditionalSignup = (payload) => {
  freezeBodyScroll();
  return {
    type: ACTION_TYPES.SESSION_CONDITIONAL_SIGNUP_OPEN,
    payload,
  };
};

const __countSessionConditinalSignup = (payload) => ({
  type: ACTION_TYPES.SESSION_CONDITIONAL_SIGNUP_COUNTER,
  payload,
});

const __validateSessionConditinalSignup = (payload) => ({
  type: ACTION_TYPES.SESSION_CONDITIONAL_SIGNUP_VALIDATE,
  payload,
});

export const dispatchSessionShowMoreSignupModal = () => (dispatch, getState) => {
  dispatch(__countSessionConditinalSignup({}));
  const {
    user,
    locals: { enableSignUpPopupForShowMore },
    modals: { sessionConditionalSignup },
  } = getState();
  const { actionDispatchCounter, isValidToTrigger } = sessionConditionalSignup;
  if (enableSignUpPopupForShowMore && isValidToTrigger) {
    const allowOpenPopup = sessionPopupService
      .sessionCondtitionalPopupHandler(user)
      .showMoreClicked(actionDispatchCounter);
    if (allowOpenPopup) {
      dispatch(__openSessionConditionalSignup({ entryPoint: POPUP_ENTRY_POINT.SHOW_MORE_POPUP }));
    }
  }
};

export const dispatchSessionBucketScrollSignupModal =
  (payload = {}) =>
  (dispatch, getState) => {
    const {
      user,
      locals: { enableSignUpPopupForJobCards },
      modals: { sessionConditionalSignup },
    } = getState();
    const { isValidToTrigger } = sessionConditionalSignup;
    if (enableSignUpPopupForJobCards && isValidToTrigger) {
      const { scrolledCardCount } = payload;
      const allowOpenPopup = sessionPopupService
        .sessionCondtitionalPopupHandler(user)
        .jobCardScrolled(scrolledCardCount);
      if (allowOpenPopup) {
        dispatch(
          __openSessionConditionalSignup({ entryPoint: POPUP_ENTRY_POINT.SCROLL_BUCKET_POPUP })
        );
      }
    }
  };

export const dispatchCloseSessionConditionalSignupModal = () => (dispatch) => {
  unFreezeBodyScroll();
  dispatch({
    type: ACTION_TYPES.SESSION_CONDITIONAL_SIGNUP_CLOSE,
  });
};

export const dispatchValidateSessionConditionalSignupModal = () => (dispatch, getState) => {
  const { user } = getState();
  const isValidToTrigger = sessionPopupService
    .sessionCondtitionalPopupHandler(user)
    .isValidToTrigger();
  dispatch(__validateSessionConditinalSignup(isValidToTrigger));
};

const __openGatedSignupPopup = (payload) => ({
  type: ACTION_TYPES.GATED_SIGNUP_OPEN,
  payload,
});

const __closeGatedSignupPopup = (payload) => ({
  type: ACTION_TYPES.GATED_SIGNUP_CLOSE,
  payload,
});

export const dispatchOpenGatedSignupPopup =
  (payload = {}) =>
  (dispatch, getState) => {
    const {
      modals: { gatedSignup, signUp, signupRecaptcha },
    } = getState();
    if (!gatedSignup.open && !signUp.open && !signupRecaptcha.open) {
      dispatch(__openGatedSignupPopup(payload));
    }
  };

export const dispatchCloseGatedSignupPopup =
  (payload = {}) =>
  (dispatch) => {
    dispatch(__closeGatedSignupPopup(payload));
  };

// Embed widget popup
const openEmbedWidget = (payload) => ({
  type: ACTION_TYPES.EMBED_WIDGET_OPEN,
  payload,
});
const closeEmbedWidget = (payload) => ({
  type: ACTION_TYPES.EMBED_WIDGET_CLOSE,
  payload,
});
export const dispatchOpenEmbedWidgetPopup = (payload) => (dispatch) => {
  dispatch(openEmbedWidget(payload));
};
export const dispatchCloseEmbedWidgetPopup = (payload) => (dispatch) => {
  dispatch(closeEmbedWidget(payload));
};

export const dispatchShareModalReviewUrl = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.SHARE_MODAl_REVIEW_URL,
    payload,
  });
};

// Signup recaptcha modal
const _openSignupRecaptcha = (payload) => ({
  type: ACTION_TYPES.SIGNUP_RECAPTCHA_OPEN,
  payload,
});
const _closeSignupRecaptcha = (payload) => ({
  type: ACTION_TYPES.SIGNUP_RECAPTCHA_CLOSE,
  payload,
});
export const dispatchOpenSignupRecaptchaModal = () => (dispatch) => {
  dispatch(_openSignupRecaptcha({}));
};
export const dispatchCloseSignupRecaptchaModal = () => (dispatch) => {
  dispatch(_closeSignupRecaptcha({}));
};

// College popup
const _openCollegePopup = (payload = {}) => {
  freezeBodyScroll(true);

  return {
    type: ACTION_TYPES.COLLEGE_POPUP_OPEN,
    payload,
  };
};

export const closeCollegePopup = (payload = {}) => {
  unFreezeBodyScroll();

  return {
    type: ACTION_TYPES.COLLEGE_POPUP_CLOSE,
    payload,
  };
};

const successCollegePopup = (payload = {}) => ({
  type: ACTION_TYPES.COLLEGE_POPUP_SUCCESS,
  payload,
});

export const openCollegePopup =
  (payload = {}) =>
  async (dispatch, getState) => {
    const popupSuccess = (result) => {
      const {
        modals: {
          collegePopup: { loading, open },
        },
      } = getState();

      if (loading && open) {
        dispatch(
          successCollegePopup({
            data: result,
          })
        );
      }
    };

    dispatch(_openCollegePopup(payload));

    const getCollege = commonService.getCollegeExtendedData({
      collegeId: payload.collegeId,
    });

    Promise.resolve(getCollege)
      .then((result) => {
        result.updatedMajors = payload.updatedMajors;
        return popupSuccess(result);
      })
      .catch((error) => console.error(error));
  };

export const openMoreWorkInfoModal = () => {
  freezeBodyScroll();
  return {
    type: ACTION_TYPES.MORE_INFO_CONFIRM_MODAL_OPEN,
  };
};

export const closeMoreWorkInfoModal = () => {
  unFreezeBodyScroll();

  return {
    type: ACTION_TYPES.MORE_INFO_CONFIRM_MODAL_CLOSE,
  };
};

export const _confirmMoreWorkInfoModal = () => {
  unFreezeBodyScroll();
  return {
    type: ACTION_TYPES.MORE_INFO_CONFIRM_MODAL_CONFIRM,
  };
};

export const confirmMoreWorkInfoModal = () => (dispatch, getState) => {
  const { user, resumeBuilder } = getState();

  const { flow } = resumeBuilder;

  const { currentStepIndex } = flow;

  dispatch(_confirmMoreWorkInfoModal());

  const payload = {
    nextStepIndex: user?.isLoggedIn ? currentStepIndex + 2 : currentStepIndex + 1,
    nextSubStepIndex: 0,
    nextBtnLabel: 'Next',
  };

  dispatch({
    type: RB_ACTION_TYPES.SET_RB_FLOW,
    payload,
  });
};

export const showCustomNotificationPrompt = () => ({
  type: ACTION_TYPES.SHOW_CUSTOM_NOTIFICATION_PROMPT,
});

export const hideCustomNotificationPrompt = () => ({
  type: ACTION_TYPES.HIDE_CUSTOM_NOTIFICATION_PROMPT,
});

export const showResumeBuilderTemplateModal = () => {
  freezeBodyScroll();
  return {
    type: ACTION_TYPES.SHOW_RB_TEMPLATES_MODAL,
  };
};

export const hideResumeBuilderTemplateModal = () => {
  unFreezeBodyScroll();
  return {
    type: ACTION_TYPES.HIDE_RB_TEMPLATES_MODAL,
  };
};

export const showResumeBuilderDelete = () => {
  freezeBodyScroll(true);
  return {
    type: ACTION_TYPES.SHOW_RB_DELETE_POPUP,
  };
};

export const hideResumeBuilderDelete = () => {
  unFreezeBodyScroll();
  return {
    type: ACTION_TYPES.HIDE_RB_DELETE_POPUP,
  };
};

export const showRBSubscriptionModal = (subscriptionStatus) => (dispatch) => {
  if (
    subscriptionStatus === RESUME_SUBSCRIPTION_STATUS.NOT_ACTIVE &&
    subscriptionStatus !== RESUME_SUBSCRIPTION_STATUS.ACTIVE
  ) {
    logEventGTM({
      event: EVENTS.checkoutPopupOpen,
    });
  }
  const shouldFreeze = subscriptionStatus !== RESUME_SUBSCRIPTION_STATUS.ACTIVE;
  if (shouldFreeze) freezeBodyScroll();
  return dispatch({
    type: ACTION_TYPES.SHOW_RB_SUBSCRIPTION_MODAL,
  });
};

export const hideRBSubscriptionModal = () => {
  unFreezeBodyScroll();
  return {
    type: ACTION_TYPES.HIDE_RB_SUBSCRIPTION_MODAL,
  };
};

export const showResetPasswordModal = (unfreezeBody) => {
  if (!unfreezeBody) freezeBodyScroll();
  return {
    type: ACTION_TYPES.SHOW_RESET_PASSWORD_MODAL,
  };
};

export const hideResetPasswordModal = (unfreezeBody) => {
  if (!unfreezeBody) unFreezeBodyScroll();
  return {
    type: ACTION_TYPES.HIDE_RESET_PASSWORD_MODAL,
  };
};

export const showJobAlertPopup =
  (operation = '') =>
  (dispatch, getState) => {
    const localStorageKey = 'jobAlertConfig';
    const jobAlertConfig = localStorage.getItem(localStorageKey);
    const pages = [
      'Site Map State', // /state-jobs/
      'City Page',
      /City [0-9A-Za-z\s]+ Jobs Page/i, // City adjective pages
      'Company Jobs Page',
      /Company [0-9A-Za-z\s]+ Jobs Page/i, // Company adjective pages
      'Career Jobs Page',
      /Career [0-9A-Za-z\s]+ Jobs Page/i, // Career adjective pages
      /Career Main Page - Job \+ City/, // + City or + state
    ];
    const { user, modals } = getState();

    if (
      !pages.some((p) => new RegExp(p).test(window.pageCategory))
      || (!user?.userId || !!user?.isLoggedIn)
      || modals.signUp.open
    ) {
      return;
    }

    if (!jobAlertConfig || operation === 'init') {
      // Initialize/Reset the counter
      localStorage.setItem(
        localStorageKey,
        JSON.stringify({
          count: 0,
          timestamp: Date.now(),
        })
      );
      freezeBodyScroll();
      dispatch({
        type: ACTION_TYPES.SHOW_JOB_ALERT_POPUP,
      });
    } else {
      // Increase the counter
      localStorage.setItem(
        localStorageKey,
        JSON.stringify({
          ...JSON.parse(jobAlertConfig),
          count: (JSON.parse(jobAlertConfig)?.count || 0) + 1,
        })
      );
    }
  };

export const hideJobAlertPopup = () => {
  unFreezeBodyScroll();
  return {
    type: ACTION_TYPES.HIDE_JOB_ALERT_POPUP,
  };
};

export const toggleRBFormatDrawer = () => {
  return {
    type: ACTION_TYPES.TOGGLE_RB_FORMAT_DRAWER,
  };
};

export const changeRBFormatSettings = (payload) => {
  return {
    type: ACTION_TYPES.CHANGE_RB_FORMAT_SETTINGS,
    payload,
  };
};

export const dispatchOpenExitIntentPopup = () => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.EXIT_INTENT_POPUP_OPEN,
  });
}

export const dispatchCloseExitIntentPopup = () => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.EXIT_INTENT_POPUP_CLOSE,
  });
}
